import { InteractionStatus } from "@azure/msal-browser";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import PATH_ROLE from "../Common/Constant/Security/PathRoleMap";

export const IsAuthenticated = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  return inProgress === InteractionStatus.None && isAuthenticated;
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiration = payload.exp;
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds

    return expiration > currentTime;
  } catch (e) {
    return false;
  }
};

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return {};
  }
};

export const hasRole = (role) => getRoles().includes(role);

const getRoles = () => {
  const t = getToken();
  if (!t) return [];
  const p = parseJwt(t);
  return Array.isArray(p.roles) ? p.roles : [];
};

export const isPathAllowed = (path) => {
  const normalized = path.toLowerCase();
  const need = PATH_ROLE[normalized];
  if (!need) return true;
  // Some paths require more than one role (mirrors ROLE_BASED_ACCESS composite checks).
  return Array.isArray(need) ? need.every(hasRole) : hasRole(need);
};

export const getTokenIssuer = () => {
  const t = getToken();
  if (!t) return [];
  const p = parseJwt(t);
  return p.iss ? p.iss : "";
};

export const getTenants = () => {
  const t = getToken();
  if (!t) return [];
  const p = parseJwt(t);
  return Array.isArray(p.tenants) ? p.tenants : [];
};

export const getUserType = () => {
  const t = getToken();
  if (!t) return "";
  const p = parseJwt(t);
  return p.userType || p.type || "";
};
